import { PropTypes } from 'prop-types';
import { Col, Row } from 'react-bootstrap';

const IrrimaxSiteLayout = ({ children }) => {
  return (
    <Row className='text-center mt-2 mb-4'>
      <Col>{children}</Col>
    </Row>
  );
};

IrrimaxSiteLayout.proptype = {
  children: PropTypes.element.isRequired
};

export default IrrimaxSiteLayout;

